// @flow

import React, { Component } from 'react';
import cx from 'classnames';
import _ from 'lodash';
import 'client/styles/selectionList.scss';
import Translate from 'client/components/translate';
import type { ToggleItemType } from 'types/toggleItemType.flow';
import {
  type ValidationErrorType,
  REQUIRED_FIELD_ERROR_PATH,
} from 'routes/marketplace/utils/validations';
import ToggleItem from './toggleItem';

export type SelectionListProps = {
  isRequired: boolean,
  allItems: Array<ToggleItemType | Object>,
  selectedItems: Array<ToggleItemType>,
  changeHandler: Function,
  className: string,
  meta?: {
    touched: boolean,
    submitFailed: boolean,
    error: ValidationErrorType,
  },
  input?: {
    onBlur: Function,
  },
};

export default class SelectionList extends Component<SelectionListProps> {
  static defaultProps = {
    selectedItems: [],
    className: '',
    isRequired: false,
    meta: {},
    input: {},
  };

  toggleItem(item: ToggleItemType) {
    const { selectedItems, isRequired, input, changeHandler } = this.props;
    const isSelected = _.some(selectedItems, { id: item.id });
    let newSelectedItems = selectedItems;

    if (isSelected) {
      newSelectedItems = _.filter(selectedItems, i => i.id !== item.id);
    } else if (item.id === 'NONE') {
      newSelectedItems = [item];
    } else {
      newSelectedItems = _.concat(_.reject(selectedItems, ['id', 'NONE']), item);
    }

    changeHandler(newSelectedItems, item);
    // trigger reduxForm to update touched=true
    if (isRequired) {
      input.onBlur();
    }
  }

  renderRequiredText = () => {
    const {
      meta: { error, touched, submitFailed },
    } = this.props;
    const shouldShowError = error && (touched || submitFailed);

    return (
      shouldShowError && (
        <Translate
          className="error-message"
          path={_.get(error, 'path', REQUIRED_FIELD_ERROR_PATH)} />
      )
    );
  };

  render() {
    const { isRequired, allItems, selectedItems, className } = this.props;

    return (
      <React.Fragment>
        {isRequired && this.renderRequiredText()}
        <div className={cx('selection-items', className)}>
          {_.map(allItems, item => (
            <ToggleItem
              key={item.id}
              item={item}
              checked={_.some(selectedItems, { id: item.id })}
              clickHandler={(e) => {
                e.preventDefault();
                this.toggleItem(item);
              }} />
          ))}
        </div>
      </React.Fragment>
    );
  }
}
